import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import CategoryPage from './pages/CategoryPage'
import ContentPage from './pages/ContentPage'
import HomePage from './pages/HomePage'
import ProductDetailPage from './pages/ProductDetailPage'
import ProductListPage from './pages/ProductListPage'

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hakkimizda" element={<ContentPage template="About" />} />
        <Route path="/iletisim" element={<ContentPage template="Contact" />} />
        <Route path="/kategoriler" element={<CategoryPage />} />
        <Route path="/kategori" element={<CategoryPage />} />
        <Route path="/urunlerimiz" element={<ProductListPage />} />
        <Route path="/urunlerimiz/:slug" element={<ProductDetailPage />} />
      </Routes>
    </Layout>
  )
}
